"use client";

import { SiteNav } from "@/components/site/site-nav";
import { SiteFooter } from "@/components/site/site-footer";
import { PricingPage } from "@/components/site/pricing-page";

// Stub — ported as-is from the v0 export (ai-dubbing-studio_2.zip), not yet
// wired to real prices/tiers. Placeholder only, per owner's request 2026-07-26.
export default function Pricing() {
  return (
    <div className="flex min-h-screen flex-col bg-background text-foreground">
      <SiteNav />
      <PricingPage />
      <SiteFooter />
    </div>
  );
}
